
import { Component, OnInit,ViewEncapsulation, OnDestroy, Inject, PLATFORM_ID, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppDataService } from '../../../services/app-data.service';
declare var adsbygoogle: any;
declare var Swiper: any;
declare var $:any;
@Component({
  selector: 'social-list',
  templateUrl: './social-list.html',
})
export class SocialListComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private _companyService: CompanyService,
    private _router: Router,
    public _appData: AppDataService,
    public _routeParams : ActivatedRoute

  ) {

  }

    public menuOpen=true;
    public menuConfig={};
    public items:any[] = [  ];
    public roomName='';
    public interval;
  ngOnDestroy(): void {

  }

  selectUser(user){
    this._appData.target=user;
    document.getElementById('reloadUser').click();
  }
  selectRoom(item){
    //fecth room to show
      //começa botando o iframe visivel
      const modal0 = document.getElementById("iframeOfGameExt");
      modal0.style.visibility = "visible";    
      modal0['src']=item.video ? item.video : '';
      //e ligando o modal
      const modal = document.getElementById("social-modal");
      modal.style.display = "flex";     
      this._appData.socialRoom=item;
  
    if (item.kind=='link' && item.link && item.link.length>0){
      this._appData.room=item;
    }
    else{
    //pega detalhes da sala e do item
      this._companyService.getRoom(item.id).get().then((roomd) => {
        let room=roomd.data();
        let itens=[]
        this._companyService.getUserRoomItemRef(room.id).get().then(it=>{
              it.forEach(v=>{
                let item=v.data();
                itens.push(item)
              })
              room.userItens=itens;
              this._appData.room=room;


        });
      })
    }
    //update Views
    this._companyService.viewRoom(this._appData.instagramUser,item)
    this._companyService.getRoomCommentsRef(item.id).get().then((querySnapshot) => {
      let comments = [];
      querySnapshot.forEach((doc) => {
        let it = doc.data();
        comments.push(it);
      });
      this._appData.comments = comments;
    });
  }
  
  ngOnInit(): void {
    this.items=[];
    let link=''
    this._companyService.getSocialRoomRef().orderBy('id','desc').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let it=doc.data();
        this.items.push(it);
        if (!link){
          link=it.link;
          this.roomName=it.name;
        }
      });
      (adsbygoogle = window['adsbygoogle'] || []).push({});
      (adsbygoogle = window['adsbygoogle'] || []).push({});

    }).catch((error) => {
      console.error("Error getting documents: ", error);
    });


  }
 }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/social/social-list/social-list.ts